import {permiteRol,puedeOperarReserva} from './permisosRol';
import { puedeAccederEvento } from './accessPolicy';

export const titularReserva = (reserva) => reserva?.propietarioUid ?? reserva?.atribuidoAUid ?? reserva?.creadoPorUid ?? null;
export function puedeGestionarReserva(perfil, uid, reserva, evento) {
  return ['crear','prepagar','adicionales','trasladar','liberar','modificar','entradas','intercambiar','paquete','cancelar'].some(k=>permiteRol(perfil,'reservas.'+k)) && !!uid && !!reserva && puedeAccederEvento(perfil, evento, 'reservas') &&
    puedeOperarReserva(perfil,uid,reserva);
}

export const nombreTitularReserva = r => r?.propietarioNombre || (r?.atribuidoAUid ? r.atribuidoANombre : r?.creadoPorNombre) || 'Titular sin nombre histórico';
